import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import { createContext } from 'react';
import { useState } from 'react';

import cadastro from './components/pages/cadastro';
import home from './components/pages/home';
import porqueSeCadastrar from './components/pages/porque-se-cadastrar';
import objetivo from './components/pages/objetivo';
import requisitos from './components/pages/requisitos';
import CadastroCachorro from './components/pages/cadastro-cachorro';
import CadastroGato from './components/pages/cadastro-gato';
import admin from './components/pages/admin';
import CadastroSucesso from './components/pages/cadastro-sucesso';
import Parceiros from './components/pages/parceiros';
import Sangue from './components/pages/sangue';
import Numeros from './components/pages/numeros';
import MateriaisBibliograficos from './components/pages/bibliograficos';
import Perfil from './components/pages/perfil';
import Busca from './components/pages/busca';
import { User } from './UserContext';

function App() {
    const [user, setUser] = useState();
    return (
        <User.Provider value={[user, setUser]}>
          <Router>
              <Navbar />
              <Switch>
                  <Route path='/' exact component={home} />
                  <Route path='/parceiros' exact component={Parceiros} />
                  <Route path='/cadastro' exact component={cadastro} />
                  <Route path='/porque-se-cadastrar' exact component={porqueSeCadastrar} />
                  <Route path='/objetivo' exact component={objetivo} />
                  <Route path='/requisitos' exact component={requisitos} />
                  <Route path='/cadastro-cachorro' exact component={CadastroCachorro} />
                  <Route path='/cadastro-gato' exact component={CadastroGato} />
                  <Route path='/admin' exact component={admin} />
                  <Route path='/sangue' exact component={Sangue} />
                  <Route path='/numeros' exact component={Numeros} />
                  <Route path='/bibliograficos' exact component={MateriaisBibliograficos} />
                  <Route path='/perfil' exact component={Perfil} />
                  <Route path='/cadastro-sucesso' exact component={CadastroSucesso} />
                  <Route path='/busca' exact component={Busca} />
              </Switch>
          </Router>
      </User.Provider>
  );
}

export default App;
